
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Menu from "./Menu";

const STANDALONE_MAIN_PATH = [
    "/casting/message/",
    "/my",
    "/follow",
    "/wannabe"
];

const Layout = () => {
    const location = useLocation();
    const needStandaloneMain = STANDALONE_MAIN_PATH.some(path => location.pathname.includes(path));

    return (
        <>
            {needStandaloneMain ? null : <Header />}
            <Outlet />
            {needStandaloneMain ? null : <Menu />}
        </>
    );
};

export default Layout;